import { lazy } from 'react';
import Loadable from '../components/Loadable';
import LoginLayout from '../layouts/LoginLayout';

 
const LoginPage     = Loadable(() => import('../pages/auth/LoginPage'));
const RegisterPage  = Loadable(()=>import('../pages/auth/RegisterPage'));
const RecoveryPage  = Loadable(()=>import('../pages/auth/RecoveryPage'));


const LoginRoutes = {
    element: <LoginLayout/>, 
    children: [
        {
            path: '/login',
            element: <LoginPage/>
        },
        {
            path: '/register',
            element: <RegisterPage/>
        },
        {
            path: '/recovery',
            element: <RecoveryPage/>
        }
    ]
}

export default LoginRoutes;